import get from 'lodash.get';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import * as SellerActions from '../../store/seller/seller.actions';

import * as Actions from './user.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

const initialState = {
  currentUser: emptyObject,
  userSettings: emptyArray,
  userSettingsReady: false,
};

const handleUserSettingSaveRequestSuccess = (state, action) => {
  const { setting } = action;
  const { userSettings } = state;
  return {
    ...state,
    userSettings: [...userSettings.filter((s) => s.settingName !== setting.settingName), setting],
  };
};

export const reduce = (state = initialState, action) => {
  const { currentUser, data } = action;
  const userSettings = get(data, 'userSettings', emptyArray);
  switch (action.type) {
    case Actions.CURRENT_USER_GET_SUCCESS:
      return {
        ...state,
        currentUser,
      };
    case APP_INITIALIZATION:
      return {
        ...state,
        currentUser: action.initialData.currentUser,
        userSettings: action.initialData.userSettings,
        userSettingsReady: true,
      };
    case SellerActions.GET_SELLER_DATA_SUCCESS:
      return {
        ...state,
        userSettings,
        userSettingsReady: true,
      };
    case Actions.USER_SETTING_SAVE_REQUEST_SUCCESS:
    case Actions.UPDATE_USER_SETTING:
      return handleUserSettingSaveRequestSuccess(state, action);
    case Actions.UPDATE_USER_SETTINGS_BULK:
      return {
        ...state,
        userSettings: action.newSettings || emptyArray,
      };
    default:
      return {
        ...state,
      };
  }
};

export { namespace } from './user.reducer.metadata';
